// extracted by mini-css-extract-plugin
export default {"overlay":"ZoomableImage_overlay__jEq8f","image":"ZoomableImage_image__84mDa","modal":"ZoomableImage_modal__yp3-x","modal__image":"ZoomableImage_modal__image__648Ng"};